const INITIAL_STATE = {
  industrializados: [],
  pagination: {
    page: 1,
    itemsPerPage: 15,
    totalItem: 0
  },
  search: {
    ref: ''
  }
}

export default function favoriteIndustrializadosReducer(state = INITIAL_STATE, action) {
  switch (action.type) {
    case 'FAVORITES_INDUSTRIALIZADOS_SET_INDUSTRIALIZADOS':
      return {
        ...state,
        industrializados: action.payload
      }
    case 'FAVORITES_INDUSTRIALIZADOS_SET_PAGE':
      return {
        ...state,
        pagination: {
          ...state.pagination,
          page: action.payload
        }
      }
    case 'FAVORITES_INDUSTRIALIZADOS_SET_ITEMS_PER_PAGE':
      return {
        ...state,
        pagination: {
          ...state.pagination,
          itemsPerPage: action.payload
        }
      }
    case 'FAVORITES_INDUSTRIALIZADOS_SET_TOTAL_ITEMS':
      return {
        ...state,
        pagination: {
          ...state.pagination,
          totalItems: action.payload
        }
      }
    case 'FAVORITES_INDUSTRIALIZADOS_SET_REF':
      return {
        ...state,
        search: {
          ...state.search,
          ref: action.payload
        }
      }
    case 'FAVORITES_INDUSTRIALIZADOS_CLEAR_ALL':
      return {
        ...state,
        ...INITIAL_STATE
      }
    default:
      return state
  }
}
